"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "roccarainola": {
    "b46ab610": [{
      "hkey": "35404d64",
      "slug": "roccarainola",
      "name": "Roccarainola",
      "primary": true,
      "skipSearch": false
    }],
    "c5f53f06": [{
      "hkey": "35404d64",
      "slug": "roccarainola",
      "name": "Roccarainola",
      "primary": true,
      "skipSearch": false
    }],
    "gargani": [{
      "hkey": "35404d64",
      "slug": "roccarainola",
      "name": "Roccarainola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a04a3cbc": [{
      "hkey": "35404d64",
      "slug": "roccarainola",
      "name": "Roccarainola",
      "primary": true,
      "skipSearch": false
    }],
    "piazza": [{
      "hkey": "35404d64",
      "slug": "roccarainola",
      "name": "Roccarainola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0d11cd57": [{
      "hkey": "35404d64",
      "slug": "roccarainola",
      "name": "Roccarainola",
      "primary": true,
      "skipSearch": false
    }],
    "sasso": [{
      "hkey": "35404d64",
      "slug": "roccarainola",
      "name": "Roccarainola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fellino": [{
      "hkey": "35404d64",
      "slug": "roccarainola",
      "name": "Roccarainola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;